import { LegalLayout } from "@/components/LegalLayout";

export default function TermsOfUse() {
  return (
    <LegalLayout eyebrow="— Pravne informacije" title="Uvjeti korištenja" lastUpdated="prosinac 2025.">
      <p>
        Pristupom i korištenjem internetske stranice <em>lamaisonbyfp.com</em> prihvaćate ove Uvjete korištenja.
        Ako se s njima ne slažete, molimo Vas da ne koristite stranicu.
      </p>

      <h2>1. Pružatelj usluga</h2>
      <p>
        Stranicu vodi <strong>La Maison by FP, obrt za frizerske usluge</strong>, vl. Filip Pitinac, Matije
        Gupca 6, 31400 Đakovo, OIB: 70763675453. Detaljne informacije nalaze se u <a href="/impressum">Impressumu</a>.
      </p>

      <h2>2. Sadržaj stranice</h2>
      <p>
        Sav sadržaj (tekstovi, fotografije, logotip, dizajn) vlasništvo je obrta La Maison by FP, odnosno
        autora s kojima imamo odgovarajući ugovor. Sadržaj se ne smije kopirati, preraditi niti komercijalno
        koristiti bez pisanog odobrenja. Citiranje uz navođenje izvora dopušteno je za nekomercijalne svrhe.
      </p>

      <h2>3. Online rezervacija</h2>
      <p>
        Slanjem obrasca za rezervaciju klijent daje obrtu zahtjev za zakazivanje termina. Termin se smatra
        <strong> potvrđenim tek nakon što djelatnik salona kontaktira klijenta</strong> putem e-maila ili telefona.
        Detaljnije u <a href="/pravila-rezervacije">Pravilima rezervacije i otkazivanja</a>.
      </p>

      <h2>4. Točnost podataka</h2>
      <p>
        Klijent je dužan unijeti istinite i točne podatke. Obrt zadržava pravo odbiti rezervaciju u slučaju
        očito netočnih, nepotpunih ili sumnjivih podataka.
      </p>

      <h2>5. Cijene</h2>
      <p>
        Cijene navedene u cjeniku okvirne su i izražene u eurima (EUR). Konačnu cijenu salon definira nakon
        kratke analize kose i dogovora oko željenog rezultata. PDV je uračunat u cijene (ako je primjenjivo).
      </p>

      <h2>6. Ograničenje odgovornosti</h2>
      <p>
        Trudimo se osigurati točnost i ažurnost podataka, no ne jamčimo njihovu potpunu točnost niti
        dostupnost stranice bez prekida. La Maison by FP ne odgovara za bilo kakvu posrednu štetu nastalu
        korištenjem stranice.
      </p>

      <h2>7. Vanjske poveznice</h2>
      <p>
        Stranica može sadržavati poveznice na vanjske web-stranice (npr. Instagram, Google Maps). Ne odgovaramo
        za sadržaj i politike privatnosti tih trećih strana.
      </p>

      <h2>8. Privatnost i kolačići</h2>
      <p>
        Obrada osobnih podataka opisana je u <a href="/pravila-privatnosti">Politici privatnosti</a>,
        a korištenje kolačića u <a href="/kolacici">Politici kolačića</a>.
      </p>

      <h2>9. Mjerodavno pravo</h2>
      <p>
        Na ove Uvjete primjenjuje se pravo Republike Hrvatske. Za sve sporove nadležan je stvarno nadležni
        sud u Osijeku.
      </p>

      <h2>10. Izmjene Uvjeta</h2>
      <p>
        La Maison by FP zadržava pravo izmjena Uvjeta korištenja u bilo kojem trenutku. Izmijenjeni Uvjeti
        stupaju na snagu objavom na ovoj stranici.
      </p>
    </LegalLayout>
  );
}
